import { faBarChart, faBars, faBell, faCalendar, faCarBurst, faDatabase, faFileArchive, faSignsPost } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FloatButton } from 'antd';
import FloatButtonGroup from 'antd/es/float-button/FloatButtonGroup';
import FloatButtonComp from 'components/FloatButton';

type Props = {
    openMenuItem: (type: string) => void;
}

const MapViewMenu = ({ openMenuItem }: Props) => {
    return (
        <div>
            <div style={{ position: 'absolute', top: 20, right: 20, zIndex: 1000 }}>
                <FloatButtonGroup
                    tooltip="Menú de opciones"
                    trigger="click"
                    type="primary"
                    style={{ marginBottom: "85vh" }}
                    icon={<FontAwesomeIcon icon={faBars} />}
                    placement='left'
                >
                    <FloatButton icon={<FontAwesomeIcon icon={faCalendar} />} tooltip='Gestión de Turnos' onClick={() => openMenuItem('gestion-turnos')} />
                    <FloatButton icon={<FontAwesomeIcon icon={faBarChart} />} tooltip='Gráficos de Tendencia' onClick={() => openMenuItem('graficos-tendencia')} />
                    <FloatButton icon={<FontAwesomeIcon icon={faFileArchive} />} tooltip='Reportes' onClick={() => openMenuItem('reportes')} />
                    <FloatButton icon={<FontAwesomeIcon icon={faSignsPost} />} tooltip='Planes de Señalización' onClick={() => openMenuItem('planes-señalizacion')} />
                    <FloatButton icon={<FontAwesomeIcon icon={faCarBurst} />} tooltip='Incidencias' onClick={() => openMenuItem('gestion-incidentes')} />
                    <FloatButton icon={<FontAwesomeIcon icon={faDatabase} />} tooltip='Inventario' onClick={() => openMenuItem('inventario')} />
                </FloatButtonGroup>
            </div>
            <FloatButtonComp
                onClick={() => openMenuItem('gestion-alarmas')}
                right={"20px"}
                bottom={"16em"}
                icon={faBell}
                tooltipLabel='Control de Alarmas'
            />
        </div>
    )
}

export default MapViewMenu